import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Icons } from '@/utils/Icons';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { clearBet } from '@/store/slices/betSlice';
import BetSlipForm from './bet/BetSlipForm';
import MyBets from './MyBets';

const Panel = ({
  title,
  icon,
  action,
  children,
}: {
  title: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
}) => (
  <section className="overflow-hidden rounded-xl border border-shell-border bg-shell-panel">
    <div className="flex items-center justify-between gap-2 px-4 py-3">
      <h3 className="flex items-center gap-2 text-sm font-semibold text-shell-fg">
        {icon}
        {title}
      </h3>
      {action}
    </div>
    {children}
  </section>
);

/** Desktop right rail on the match page: live TV, bet slip and the user's bets. */
const BettingContainer = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { selectedBet } = useAppSelector((state) => state.bet);
  const { liveTvUrl } = useAppSelector((state) => state.media);
  const [openTv, setOpenTv] = useState(false);

  useEffect(() => {
    dispatch(clearBet());
  }, [location.pathname]);

  return (
    <aside className="sticky top-[84px] m-3 ml-0 max-h-[calc(100vh-96px)] w-[340px] shrink-0 space-y-3 self-start overflow-y-auto max-xl:hidden 2xl:w-[380px]">
      {liveTvUrl && (
        <Panel
          title="Live Match"
          icon={<Icons.Tv className="text-success-emerald" />}
          action={
            <button
              type="button"
              onClick={() => setOpenTv((prev) => !prev)}
              className="text-xs font-semibold text-gold hover:underline"
            >
              {openTv ? 'Hide' : 'Watch'}
            </button>
          }
        >
          {openTv && (
            <div className="aspect-video w-full border-t border-shell-border">
              <iframe scrolling="no" title="Live TV" className="h-full w-full" src={liveTvUrl} />
            </div>
          )}
        </Panel>
      )}

      {selectedBet ? (
        <BetSlipForm />
      ) : (
        <Panel title="Bet Slip" icon={<Icons.deposit className="text-gold" />}>
          <p className="border-t border-shell-border px-4 py-6 text-center text-sm text-shell-muted">
            Click on any odds to add a selection to your bet slip.
          </p>
        </Panel>
      )}

      <Panel title="My Bets">
        <MyBets />
      </Panel>
    </aside>
  );
};

export default BettingContainer;
